const initialState = () => ({
  // { [offer_id]: count } — only ever populated for admin / sales-master.
  offerDownloadCounts: {},
  offerDownloadHistory: [],
  offerDownloadHistoryTotal: 0,
});

export default {
  state: initialState(),
  actions: {
    // Downloads are logged server-side by the offers-export endpoint, so there
    // is no "log" action here — only the reads.
    async loadOfferDownloadCounts({ commit, getters }, payload = {}) {
      if (!getters.canViewDownloadAnalytics) return false;

      const offerIds = (payload.offer_ids || []).map((id) => Number(id)).filter((id) => !!id);
      if (offerIds.length === 0) return false;

      // Sub-path of the same parent route: `id` is appended as a path segment
      // and stripped from the query, giving GET offer-downloads/counts.
      let res = await this._vm.$api.get("OfferDownload", { id: "counts", offer_ids: offerIds });
      if (res.status === 200) {
        commit("setOfferDownloadCounts", res.data.data);
      }
      return res.status === 200;
    },

    async loadOfferDownloadHistory({ commit }, payload = {}) {
      let res = await this._vm.$api.get("OfferDownload", payload);
      if (res.status === 200) {
        commit("setOfferDownloadHistory", res.data);
      }
      return res.status === 200;
    },
  },

  mutations: {
    // Merge rather than replace: counts are fetched per offer subset.
    setOfferDownloadCounts(state, data) {
      state.offerDownloadCounts = { ...state.offerDownloadCounts, ...data };
    },
    setOfferDownloadHistory(state, data) {
      state.offerDownloadHistory = data.data || [];
      state.offerDownloadHistoryTotal = data.meta ? data.meta.total : 0;
    },
    ResetOfferDownload(state) {
      const newState = initialState();
      Object.keys(newState).forEach((key) => {
        state[key] = newState[key];
      });
    },
  },

  getters: {
    getOfferDownloadCounts: (state) => state.offerDownloadCounts,
    getOfferDownloadCount: (state) => (id) => state.offerDownloadCounts[id] || 0,
    getOfferDownloadHistory: (state) => state.offerDownloadHistory,
    getOfferDownloadHistoryTotal: (state) => state.offerDownloadHistoryTotal,
  },
};
